// Material UI
import { Grid } from "@mui/material";
// Components
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";
import CITDataTable from "./Tables/CITDataTable";

// Images
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";
// Hooks
import { useCitContextData } from "@/DataPages/context/cit/CitContext";

interface ICitModelTableProps {
	dataPresent: boolean;
	isLoading: boolean;
	isFetching: boolean;
}

export const CitModelTable = (props: Readonly<ICitModelTableProps>) => {
	const { dataPresent, isFetching, isLoading } = props;

	const { receivables } = useCitContextData();

	if (isLoading) {
		return (
			<Grid item xs={12} mt={1}>
				<TableLoader toolbar buttons={3} content rows={5} multiTitles={5} />
			</Grid>
		);
	}

	return (
		<Grid container alignContent="flex-start" className="h-full">
			<Grid container item>
				<Grid item xs={12} height={600}>
					{!receivables?.length ? (
						<EmptyBody
							image={dataPresent ? emptyTable : empty}
							title={dataPresent ? "No Contracts In Transit to show" : "No Pay Period selected"}
							bodyHeight={dataPresent ? "435px" : "510px"}
							className="!shadow-none"
						/>
					) : (
						<CITDataTable isFetching={isFetching} />
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};
